import RestResource from '../rest.service';

export default class ConceptPaymentService extends RestResource {
  constructor(params) {
    super('concept-payments', params);
  }
}
